module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAMAAAC6V+0/AAAAaVBMVEUAAAAzMzMyMjIzMzMzMzMzMzMzMzM1NTUzMzMyMjIyMjIzMzMwMDAzMzMzMzMyMjIzMzMzMzMzMzMxMTEzMzMyMjI3NzczMzMzMzMzMzMxMTEyMjIzMzM0NDQzMzMxMTEzMzM0NDQzMzMvA+4JAAAAI3RSTlMA/4BVqpw9Rb8krHQg9ZZH1AXrNFpmDrUZ3CqE8UD6OR5Jn1gzI2AAAACXSURBVHicjdDXDsMgDAVQLoFA9t5p1v9/ZFMCEbRSFT9Y1pFtySZ/Q6SpcMU/ZpQl5sM3UvEFCT/bBE+w8EohBV9Nw8pBNdqbHiJ9/SKDg5Qp85xxD+wygxFapcpaRAp3ZGf25MdIhl1hoCf0ruAqJEZjI6SuNuQGc2z3k4AmJiRugPtNhPQdMAxA19sXF/UUhlNd2PYVbwdJBURIZtRgAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/login/safety.png
// module id = jZY0
// module chunks = 0